import React from "react";
import pdf from './resources/pdf.pdf';

import BasePdf from "../Base/pdf";

const CommercialModulePdf = () => {
    return <BasePdf
        pdf={pdf}
    >
        JAK TO TEDY JE<br/>
        <br/>
        JAK SE URČUJE KOMERČNÍ POTENCIÁL?<br/>
        Případný komerční potenciál nápadů či projektů založených na výzkumné a vývojové činnosti je dobré rozeznat ve
        velmi rané fázi. Hodnocení komerčního, neboli aplikačního potenciálu, myšlenek a nápadů je většinou náročný a
        dlouhodobý proces vyžadující poměrně velké úsilí a časovou kapacitu pracovníků, kteří mají na starosti
        technologický a znalostní transfer, vlastních výzkumníků, nezávislých expertů či spolupracujících komerčních
        partnerů.<br/>
        <br/>
        Stupňovité hodnocení<br/>
        První kolo hodnocení výstupů výzkumných projektů by mělo probíhat ihned po nahlášení či indikaci výstupu, který
        se dostane do centra transferu technologií či inkubátoru. Toto první kolo by nemělo trvat déle než několik
        týdnů. Při seznámení s výzkumným projektem by měla proběhnout „inventura“ výstupů a jejich rychlé zhodnocení. V
        rámci tohoto prvního kola hodnocení je důležité udržet efektivitu a snažit se poskytnout jednotlivci či
        výzkumnému týmu možnost zvýšení hodnot jeho výsledků a podporovat ho v odstraňování nejistot a rizik.<br/>
        <br/>
        Druhý stupeň hodnocení komerčního potenciálu by měl být v rozsahu odpovídajícímu vytvoření studie
        proveditelnosti (nebo tzv. strategické analýzy projektu). Výstupní dokument, ideálně v rozsahu dvou až pěti
        stran textu, by měl obsahovat jednotlivé faktory ovlivňující potenciál projektu. U každého by mělo být shrnutí
        významných skutečností a rizik v dané oblasti. Konkrétní obsah by měl být opět upraven podle specifik oboru, ale
        obecná témata mohou být následující:<br/>
        • ochrana duševního vlastnictví<br/>
        • benchmarking tj. porovnání nové technologie se současně dostupnými řešeními<br/>
        • srovnání s technologiemi, které jsou ve vývoji a na trh se dostanou v budoucnu<br/>
        • tržní potenciál technologie (velikost a dostupnost trhu…)<br/>
        • náročnost dalšího vývoje<br/>
        • existence týmu a potřeba expertizy pro proces komercializace<br/>
        • identifikace „Showstoppers“ mj. v oblasti certifikace, regulace atd.<br/>
        Nejdůležitější závěry pak mohou být zachyceny v krátkém shrnutí doplněném například SWOT analýzou.<br/>
        <br/>
        Třetí, popřípadě další úrovně hodnocení komerčního potenciálu, se zpravidla propojují s inkubačním procesem a
        přípravou vlastního projektu na komercializaci. Snahou všech těchto aktivit je eliminace slabých stránek
        projektu či doplnění chybějících dat. Ze strategické analýzy je možné odvodit strategie dalšího rozvoje. Takto
        vzniklý business plán je pak kontinuálně upravován a zpřesňován a můžeme ho využít při hledání partnerů a
        investorů, nebo pří vyjednávání o hodnotě nabízeného projektu.<br/>
        <br/>
        Faktory ovlivňující komerční a aplikační potenciál<br/>
        Faktory, které ovlivňují komerční potenciál, je možné rozdělit do několika kategorií. Za prvé se jedná tzv.
        faktory „tvrdé“ tj. pevně daná fakta. Za druhé jde o tzv. „měkké“ faktory. U tvrdých faktorů uvedeme jako první
        technologické faktory, kam patří technické vlastnosti – především novost a inovativnost řešení. Je ale nutné
        zdůraznit, že míra novosti a inovativnosti je značně subjektivním faktorem. Dalším důležitým faktorem je zralost
        technologie. Ta totiž významně ovlivňuje rizikovost případných investic. Zralostí je myšleno, jak daleko od
        praktického využití<br/>
        se technologie nachází. Dále musíme brát do úvahy tržní a ekonomické faktory. Mezi globální faktory řadíme
        faktory ovlivňující investiční rozhodování firem, například vývoj světového hospodářství. Mezi lokální faktory
        řadíme například intenzitu konkurence, velikost, nasycenost či segmentaci trhu. Dalšími důležitými faktory jsou
        legislativní a regulační mechanismy. Ty hrají poměrně velkou roli v rámci zvolené formy ochrany duševního
        vlastnictví. Může se jednat také o obecné předpisy v oblasti ochrany životního prostředí či bezpečnosti
        práce.<br/>
        <br/>
        U měkkých faktorů můžeme zmínit například motivaci vědeckých pracovníků, jejich zkušenosti s podnikáním, dále
        složení týmu, který je do procesu komercializace zapojen. Poměrně významná je motivace vědeckých pracovníků, kdy
        můžeme motivační faktory rozdělit na finanční a nefinanční.<br/>
        <br/>
        <br/>
        OCEŇOVÁNÍ duševního vlastnictví<br/>
        Je nutno mít na paměti, že hodnotu duševního vlastnictví k danému časovému okamžiku lze stanovit vždy pouze
        odhadem. V běžné praxi akademického prostředí máme většinou k dispozici „nehotové“ výsledky, které ještě před
        vlastním využitím v praxi či uplatnění na trhu musí být dopracovány. Určit hodnoty těchto výsledků není vůbec
        jednoduché.<br/>
        <br/>
        V praxi jsou používány, případně i kombinovány, následující metody oceňování. První metodou je metoda výnosová,
        na jejímž základě je hodnota duševního vlastnictví vyjádřena prostřednictvím potenciálního úhrnu čistých výnosů,
        které je daný výstup schopen vygenerovat. Do kalkulace tak vstupují veličiny typu počtu potenciálních zákazníků,
        dosažitelné ceny služby či produktu a jejich náklady, doba možného využívání, doba trvání ochrany a další. Jedná
        se o nejčastěji a nejvýznamněji aplikovanou metodu stanovení ceny zejména pro patenty a obdobné výsledky,
        protože nejlépe zohledňuje specifický charakter duševního vlastnictví, prvky nahodilosti vytvoření vynálezů
        apod.<br/>
        <br/>
        Druhou aplikovatelnou metodou je metoda nákladová, na jejímž základě je hodnota duševního vlastnictví vyjádřena
        prostřednictvím úhrnu nákladů vynaložených na vytvoření posuzovaného výstupu. V praxi je k této metodě
        přihlíženo spíše okrajově a používá se téměř výhradně k oceňování méně sofistikovaných, rutinně dosahovaných
        výsledků typu know-how – například hodnota výsledků testování nové technologie za účelem její certifikace.<br/>
        <br/>
        Poslední aplikovanou metodou je metoda tržní komparace (metoda tržního srovnání), jejímž prostřednictvím je
        zjišťována cena výsledků pomocí srovnání s cenou jiného obdobného výsledku na bázi tržních rešerší. Z těchto
        rešerší lze zpravidla dovodit zejména procentuální výši běžného licenčního poplatku v daném sektoru
        hospodářství.<br/>
        <br/>
        Formálně může být cena duševního vlastnictví, které je výsledkem výzkumné a vývojové činnosti, stanovena či
        zjištěna zejména:<br/>
        • znalcem, případně vícero znaleckými posudky<br/>
        • interním odborným odhadem<br/>
        • výjimečně soutěží o podmínky licenční nebo jiné obdobné transakce.<br/>
        <br/>
        <br/>
    </BasePdf>
};
export default CommercialModulePdf;
